import { t } from "i18next";
import { enqueueSnackbar } from "notistack";

import { apiClient } from "../../ApiClient";
import { ContentType, IntegrationEnvironment } from "../../ServerEndpoints";
import { GetState, SetState, Store, StoreData } from "../types";

export const applyCertificate =
  (set: SetState<StoreData>, get: GetState<Store>) =>
  async (certPem: File, keyPem: File, keyPassword: string): Promise<boolean> => {
    const integrationId = get().integrationId!;
    const environment = get().environment! as IntegrationEnvironment;

    if (integrationId === undefined) {
      console.warn("Integration ID is undefined");
      return false;
    }

    if (environment === undefined) {
      console.warn("Environment is undefined");
      return false;
    }

    try {
      const response = await apiClient.http.request({
        path: `/integrations/${integrationId}/auth/certificate`,
        method: "POST",
        body: {
          certPem: certPem,
          keyPem: keyPem,
          keyPassword: keyPassword,
          environment: environment,
        },
        type: ContentType.FormData,
        validateStatus: () => true,
      });

      // Check if the response indicates an error
      if (response.status >= 400) {
        const errorMessage =
          (response.data as { error?: string })?.error || t(`error.${response.status}`) || t("error.title");
        enqueueSnackbar(errorMessage, { variant: "error" });
        return false;
      }

      await get().initialize();
      return true;
    } catch (error: any) {
      // Handle network errors or other exceptions
      const errorMessage = error?.response?.data?.error || error?.message || t("error.title");
      enqueueSnackbar(errorMessage, { variant: "error" });
      console.error("Error applying certificate:", error);
      return false;
    }
  };
